<!--
 * @Descripttion: 发起订单支付
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="pay-info-confirm">
    <BaseTable :data="dataList" :columns="tableColumns"></BaseTable>

    <div style="margin-top: 10px">
      <BaseDescriptions :border="true" :column="5">
        <BaseDescriptionsItem label="选中项目服务费订单数量">
          {{ tipsInfoData.projectServiceOrderNum }}个
        </BaseDescriptionsItem>
        <BaseDescriptionsItem label="终端结算金额">
          {{ formatter.fen2yuan(tipsInfoData.terminalSettlementAmount, '元') }}
        </BaseDescriptionsItem>
        <BaseDescriptionsItem label="关联综合服务费订单数量">
          {{ tipsInfoData.comprehensiveServiceFeeOrderNum }}个
        </BaseDescriptionsItem>
        <BaseDescriptionsItem label="综合服务费订单金额">
          {{
            formatter.fen2yuan(tipsInfoData.comprehensiveServiceFeeAmount, '元')
          }}
        </BaseDescriptionsItem>
        <BaseDescriptionsItem label="共计">
          {{ formatter.fen2yuan(tipsInfoData.totalAmount, '元') }}
        </BaseDescriptionsItem>
      </BaseDescriptions>
    </div>
    <div style="padding-bottom: 0; padding-right: 0" class="xrk-dialog__footer">
      <BaseButton type="default" @click="props.done">取消</BaseButton>
      <BaseButton :disabled="!payInfo.length" type="primary" @click="onPay">
        发起支付
      </BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';

import {
  BaseButton,
  BaseTable,
  BaseDescriptions,
  BaseDescriptionsItem,
  createDialog,
  BaseInput,
  XrkMessage
} from 'xrk-components';
import { formatter } from '@/utils';
import { maskPhone } from '@/utils/formatter';
import emitter from '../utils/event-bus';

import { submitList, paySubmit } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  orderTimeCol,
  orderTypeCol,
  projectNameCol,
  customerNameCol,
  payTypeCol,
  payPassagewayCol,
  csoPriceSumCol
} from '../fields/columns';
import { getVerifyCodeApi, operatorInfo } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    done: any;
    payInfo: any[];
  }>(),
  {
    done: () => ({}),
    payInfo: null
  }
);
const tipsInfoData = ref({
  projectServiceOrderNum: 0, //项目服务费订单数量
  terminalSettlementAmount: 0, //终端结算金额（分）
  comprehensiveServiceFeeOrderNum: 0, //关联综合服务费订单数量
  comprehensiveServiceFeeAmount: 0, //综合服务费订单金额(分)
  totalAmount: 0 //共计金额
});
const verifyCode = ref('');
const countdown = ref<number>(0);
const codeMsg = ref('获取验证码');
const phoneNumber = ref('');

const getPhoneNumber = async () => {
  const { data } = await operatorInfo({ t: Date.now() });
  phoneNumber.value = data.phone;
};
getPhoneNumber();

const getVerifyCode = async () => {
  if (countdown.value === 0) {
    await getVerifyCodeApi({
      phone: phoneNumber.value
    });
    countdown.value = 60;

    const intervalId = setInterval(() => {
      if (countdown.value === 1) codeMsg.value = '重新获取验证码';

      if (countdown.value > 0) {
        countdown.value--;
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
  }
};
const onPay = async () => {
  const isLine = props.payInfo.every(item => item.payType === 1);
  if (isLine) {
    createDialog({
      title: '支付身份校验',
      showClose: true,
      confirmBtnConfig: {
        content: '确认'
      },
      contentRender: () => {
        return (
          <div style="padding: 20px">
            <span>验证码将发送至您的手机：{maskPhone(phoneNumber.value)}</span>
            <div style="display: flex;margin-top: 20px">
              <BaseInput
                inputTextReplace
                inputTexts={['数字']}
                v-model={verifyCode.value}
                maxlength={6}
                placeholder="请输入验证码"
              />
              <BaseButton
                click={() => {
                  getVerifyCode();
                }}
                disabled={countdown.value > 0}
                type="primary"
                style="margin-left: 5px;width: 100px"
              >
                {countdown.value || codeMsg.value}
              </BaseButton>
            </div>
          </div>
        );
      },
      async beforeConfirm(done) {
        if (!verifyCode.value) {
          XrkMessage.error('请输入验证码');
          return Promise.reject();
        }
        try {
          await paySubmit({
            verifyCode: verifyCode.value,
            idList: props.payInfo.map(item => item.id)
          });
          XrkMessage.success('支付成功');
          emitter.emit('refresh-order-tabel', { data: true });
          props.done();
          done();
        } catch (err) {
          return Promise.reject();
        }
      }
    });
  } else {
    //线下支付不需要验证码
    await paySubmit({
      idList: props.payInfo.map(item => item.id)
    });
    XrkMessage.success('支付成功');
    emitter.emit('refresh-order-tabel', { data: true });
    props.done();
  }
};

const tableColumns = [
  indexCol,
  orderNoCol,
  orderTimeCol,
  orderTypeCol,
  projectNameCol,
  customerNameCol,
  payTypeCol,
  payPassagewayCol,
  csoPriceSumCol
];
const dataList = ref([]);
const getListAjax = async () => {
  const reqData = {
    supplierOrderIdList: props.payInfo.map(item => item.id)
  };
  const { data } = await submitList(reqData);

  tipsInfoData.value = {
    projectServiceOrderNum: data.projectServiceOrderNum, //项目服务费订单数量
    terminalSettlementAmount: data.terminalSettlementAmount, //终端结算金额（分）
    comprehensiveServiceFeeOrderNum: data.comprehensiveServiceFeeOrderNum, //关联综合服务费订单数量
    comprehensiveServiceFeeAmount: data.comprehensiveServiceFeeAmount, //综合服务费订单金额(分)
    totalAmount: data.totalAmount //共计金额
  };
  dataList.value = data.dataList;
};
getListAjax();
</script>
<style lang="scss"></style>
